import React, {
  useReducer,
  createContext,
  useContext,
  useState,
  useEffect,
} from "react";
import { useGET } from "@API2";
import { DeliveryEndpoints, packageDeliveries } from "@DELIVERIES";
import { FiltersContext, AuthContext } from "@CONTEXTS";
import { message, Modal } from "antd";

export const DeliveryContext = createContext({});

const initialState = {
  data: [],
  updateModal: false,
  printModal: false,
  deliveryErrorModal: false,
};

const reducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case "SET_DATA":
      return {
        ...state,
        data: payload,
      };
    case "SET_UPDATE_MODAL":
      return {
        ...state,
        updateModal: payload,
      };
    case "SET_PRINT_MODAL":
      return {
        ...state,
        printModal: payload,
      };
    default:
      break;
  }
};

const DeliveryProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const filterState = useContext(FiltersContext);
  const [loading, setLoading] = useState(true);
  const { info } = useContext(AuthContext);

  const {
    data = [],
    loading: apiloading,
    error,
    mutate,
  } = useGET(
    `${DeliveryEndpoints.preOrderDeliveries}`,
    filterState.filters
      ? `?page=${filterState.pagination.page}&limit=${
          filterState.pagination.limit
        }&barcode=${
          filterState.filters.barcode ? filterState.filters.barcode : ""
        }&customerDeliveryNo=${
          filterState.filters.customerDeliveryNo
            ? filterState.filters.customerDeliveryNo
            : ""
        }&deliveryType=${
          filterState.filters.deliveryType
            ? filterState.filters.deliveryType
            : ""
        }&warehouse=${
          filterState.filters.warehouse ? filterState.filters.warehouse : ""
        }`
      : false
  );

  useEffect(() => {
    if (!apiloading) {
      setLoading(false);
    }
  }, [apiloading]);

  const handlePackaged = async ({ record, onPrint }) => {
    Modal.confirm({
      title: "Gönderi Paketleme Onayı",
      content: `Seçilen gönderiyi paketleme onayı vermek istediğinizden emin misiniz?`,
      onOk: () => {
        return new Promise(async (resolve, reject) => {
          setLoading(true);
          const response = await packageDeliveries(record.id);
          if (response?.success) {
            message.success({
              content: response.message,
              className: "app-success-message",
            });
            if (info.authorities.includes("PRINT_BARCODE")) {
              Modal.confirm({
                title:
                  "Başarı ile paketlenen gönderinin barkodu yazdırılsın mı?",
                onOk: () => {
                  onPrint([
                    {
                      customerDeliveryNo: record.barcode,
                      totalParcels: record.totalParcels,
                    },
                  ]);
                },
                okText: "Evet",
                cancelText: "Hayır",
              });
            }

            mutate();
            setTimeout(() => {
              resolve();
            }, 500);
          } else {
            reject();
          }
          setLoading(false);
        });
      },
    });
    setLoading(true);
  };

  return (
    <DeliveryContext.Provider
      value={{
        ...state,
        dispatch,
        data,
        loading,
        error,
        mutate,
        handlePackaged,
      }}
    >
      {children}
    </DeliveryContext.Provider>
  );
};

export default DeliveryProvider;
